import { createUseStyles } from 'react-jss';
import { Theme } from '../themes/default';

const useBannerDownStyles = createUseStyles((theme: Theme) => {
    return {
        wrapper: {
            position: 'relative',
            width: '100%',
            height: '80vh',
            overflow: 'hidden',
            backgroundColor: '#000',
            marginTop: theme.spacing(4),
        },
        video: {
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            objectFit: 'cover',
        },
        overlay: {
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            gap: theme.spacing(4),
            zIndex: 1,
            backgroundColor: 'rgba(0, 0, 0, 0.35)',
        },
        title: {
            fontFamily: theme.fonts.poplar,
            color: theme.colors.latte_cream,
            fontSize: '2.2rem',
            textAlign: 'center',
            textTransform: 'uppercase',
            letterSpacing: '3px',
            margin: 0,
            lineHeight: 1.3,
            padding: '0 20px',
            [theme.breakpoints.up('sm')]: {
                fontSize: '3.5rem',
            },
            [theme.breakpoints.up('md')]: {
                fontSize: '4.5rem',
            },
        },
        playButton: {
            width: '100px',
            height: '100px',
            borderRadius: '50%',
            border: `2px solid ${theme.colors.latte_cream}`,
            backgroundColor: 'rgba(227, 203, 159, 0.8)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            cursor: 'pointer',
            transition: 'background-color 0.2s',
            '&:hover': {
                backgroundColor: 'rgba(227, 203, 159, 0.95)',
            },
        },
        playIcon: {
            width: 0,
            height: 0,
            borderTop: '20px solid transparent',
            borderBottom: '20px solid transparent',
            borderLeft: `22px solid ${theme.colors.espresso_brown}`,
            marginLeft: '5px',
        },
    };
});

export default useBannerDownStyles;